import { render, staticRenderFns } from "./StyledKeyword.vue?vue&type=template&id=49cc409e&scoped=true"
import script from "./StyledKeyword.vue?vue&type=script&lang=js"
export * from "./StyledKeyword.vue?vue&type=script&lang=js"
import style0 from "./StyledKeyword.vue?vue&type=style&index=0&id=49cc409e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc409e",
  null
  
)

export default component.exports